<template>
  <div class="custom-scroll-wrapper">
    <div v-if="!loading">
      <div>
        <v-row no-gutters class="sticky-header">
          <v-col cols="12">
            <v-card
              elevation="0"
              style="
                border-bottom: 2px solid rgba(0, 0, 0, 0.1);
                display: flex;
                justify-content: space-between;
              "
            >
              <v-card-title style="margin: 0; padding: 3px 0 2px 0">
                <p
                  class="text-h6 font-weight-bold text-left text-uppercase"
                  style="margin: 0; position: relative; top: -10px"
                >
                  Detail Pemeriksaan & Pengkajian Masalah/ Keadaan Darurat
                  <v-tooltip bottom color="grey">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        text
                        icon
                        color="grey darken-2"
                        @click="getDataFromApi"
                        style="position: relative; top: -3px"
                      >
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>refresh page</span>
                  </v-tooltip>
                </p>
                <p
                  v-if="detailData != null"
                  style="
                    position: absolute;
                    bottom: -25px;
                    left: -2px;
                    font-weight: bold;
                    padding-left: 3px;
                    font-size: 14px;
                  "
                >
                  {{ detailData.document_no }}
                </p>
              </v-card-title>
              <v-card-actions class="actionButton">
                <div
                  v-if="detailData != null"
                  style="
                    position: absolute;
                    bottom: 2px;
                    right: 0;
                    border: 1px solid black;
                  "
                >
                  <p
                    :style="`background-color: ${initialStatusColor(
                      detailData.status
                    )};
                color: white;
                font-weight: bold;
                width: 180px;
                text-align: center;
                margin:0`"
                  >
                    {{ detailData.status.name }}
                  </p>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card elevation="0" v-if="detailData != null">
              <v-card-text style="padding: 5px 0; margin: 0">
                <p
                  style="
                    position: absolute;
                    top: -2px;
                    left: -2px;
                    font-weight: bold;
                    padding-left: 4px;
                    font-size: 12px;
                  "
                >
                  Tgl. Buat: {{ detailData.created_at }} |
                  {{ detailData.created_by_name }}
                </p>
              </v-card-text>
              <v-card-actions
                v-if="
                  getUserProfile.level.find(
                    ({ id }) =>
                      id == appLevel.adminK3 ||
                      id == appLevel.picK3 ||
                      id == appLevel.viewer ||
                      id == appLevel.administrator
                  ) != undefined
                "
              >
                <div
                  v-if="!isEdit"
                  style="
                    position: absolute;
                    top: 0;
                    right: 0;
                    padding-left: 2px;
                  "
                >
                  <div
                    class="d-flex"
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.picK3 ||
                          id == appLevel.administrator
                      ) != undefined &&
                      (detailData.status.id == 0 ||
                        detailData.status.id == 2 ||
                        detailData.status.id == 5)
                    "
                  >
                    <v-btn
                      v-if="detailData.status.id == 0"
                      style="font-weight: bold"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click.prevent="enableEdit"
                    >
                      <v-icon
                        x-small
                        color="primary"
                        style="position: relative; top: 1px"
                      >
                        mdi-pencil
                      </v-icon>
                      Edit Header
                    </v-btn>
                    <v-btn
                      v-if="detailData.status.id == 0"
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="success"
                      @click="submitReportDocument"
                    >
                      SUBMIT
                    </v-btn>
                    <v-btn
                      v-if="
                        getUserProfile.level.find(
                          ({ id }) =>
                            id == appLevel.adminK3 ||
                            id == appLevel.administrator
                        ) != undefined && detailData.status.id == 2
                      "
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click="verifyReport"
                    >
                      Verify
                    </v-btn>
                    <v-btn
                      v-if="
                        getUserProfile.level.find(
                          ({ id }) =>
                            id == appLevel.adminK3 ||
                            id == appLevel.administrator
                        ) != undefined && detailData.status.id == 5
                      "
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="red"
                      @click="cancelReportDocument"
                    >
                      CANCEL
                    </v-btn>
                    <v-btn
                      v-if="
                        detailData.status.id == 0 || detailData.status.id == 2
                      "
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="red"
                      @click="cancelReportDocument"
                    >
                      CANCEL
                    </v-btn>
                  </div>
                  <div
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.picK3 ||
                          id == appLevel.administrator
                      ) != undefined &&
                      (detailData.status.id == 3 || detailData.status.id == 4)
                    "
                  >
                    <v-btn
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click="setDraftReport"
                    >
                      SET DRAFT
                    </v-btn>
                  </div>
                  <div
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.viewer ||
                          id == appLevel.administrator
                      ) != undefined && detailData.status.id == 1
                    "
                  >
                    <div v-if="isAllowApprove">
                      <v-btn
                        style="font-weight: bold; margin-left: 5px"
                        x-small
                        text
                        outlined
                        color="success"
                        @click="confirmReportDocument"
                      >
                        CONFIRM
                      </v-btn>
                      <v-btn
                        style="font-weight: bold; margin-left: 5px"
                        x-small
                        text
                        outlined
                        color="red"
                        @click="rejectReportDocument"
                      >
                        REJECT
                      </v-btn>
                    </div>
                  </div>
                </div>

                <div
                  v-else
                  style="
                    position: absolute;
                    top: 0;
                    right: 0px;
                    padding-left: 2px;
                  "
                >
                  <v-btn
                    style="font-weight: bold"
                    x-small
                    text
                    outlined
                    color="primary"
                    type="button"
                    @click="saveForm"
                  >
                    <v-icon
                      x-small
                      color="primary"
                      style="position: relative; top: 1px"
                    >
                      mdi-content-save-edit-outline
                    </v-icon>
                    Save
                  </v-btn>
                  <v-btn
                    style="font-weight: bold; margin-left: 10px"
                    x-small
                    text
                    outlined
                    color="red"
                    @click="enableEdit"
                  >
                    <v-icon
                      x-small
                      color="red"
                      style="position: relative; top: 1px"
                    >
                      mdi-cancel
                    </v-icon>
                    Cancel
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="detailData != null" no-gutters class="my-5">
          <v-expansion-panels
            v-model="panel"
            focusable
            multiple
            tile
            class="mt-1"
          >
            <v-expansion-panel
              v-for="(item, index) in rootCauseSection"
              :key="index"
            >
              <v-expansion-panel-header color="#ccdbdc">
                <p style="font-weight: bold; margin: 0">
                  {{ toRoman(index + 1) }}. {{ item.toUpperCase() }}
                </p>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div
                  v-if="index == 0"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      ref="rootProblemReportFormRef"
                      :readonly="!isEdit"
                      @submit.prevent="saveFormUraian"
                      style="margin: 10px 0"
                    >
                      <div v-for="item in dropdown.desccategory" :key="item.id">
                        <v-row>
                          <v-col
                            cols="12"
                            md="3"
                            class="d-flex justify-start align-center"
                          >
                            <p
                              class="text-left"
                              style="
                                margin: 0;
                                font-size: 12px;
                                font-weight: bold;
                                text-transform: uppercase;
                              "
                            >
                              {{ item.name }}
                            </p>
                          </v-col>

                          <v-col cols="12" md="9">
                            <v-textarea
                              v-model="item.description"
                              rows="2"
                              :auto-grow="true"
                              dense
                              outlined
                              style="font-size: 12px"
                              :clearable="isEdit"
                            />
                          </v-col>
                        </v-row>
                      </div>
                    </v-form>
                  </v-card>
                </div>
                <!-- Kesimpulan -->
                <div
                  v-else-if="index == 1"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      :readonly="!isEdit"
                      ref="rootProblemReportFormRef"
                      @submit.prevent="saveForm"
                      style="margin: 10px 0"
                    >
                      <v-row>
                        <v-col cols="12">
                          <div v-if="isEdit" style="overflow: hidden">
                            <!-- vue editor deprecated its causing DOMNodeInserted warning -->
                            <vue-editor
                              v-model="detailData.conclusion"
                              class="textEditor"
                            ></vue-editor>
                          </div>
                          <div v-else>
                            <div
                              v-if="detailData.conclusion"
                              v-html="detailData.conclusion"
                              style="
                                padding: 15px;
                                border: 1px solid rgba(0, 0, 0, 0.1);
                              "
                            ></div>
                            <v-card
                              v-else
                              flat
                              height="30vh"
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-toolbar-title class="overline">
                                Data Not Found</v-toolbar-title
                              >
                            </v-card>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                </div>
                <!-- Dokumentasi before -->
                <div v-else-if="index == 2" style="min-height: 40vh">
                  <v-card elevation="0">
                    <v-card-text class="d-flex justify-center align-center">
                      <v-row>
                        <v-col
                          v-if="
                            detailData.before_corrective == null ||
                            detailData.before_corrective.length == 0
                          "
                          cols="12"
                          class="d-flex justify-center align-center"
                          style="padding: 0; min-height: 20vh"
                        >
                          <div
                            style="
                              padding: 0 10px;
                              color: grey;
                              font-weight: bold;
                              font-size: 14px;
                            "
                          >
                            BELUM ADA PHOTO
                          </div>
                        </v-col>

                        <v-col
                          v-else
                          cols="12"
                          style="min-height: 20vh"
                          class="d-flex"
                        >
                          <div
                            v-for="(
                              item, index
                            ) in detailData.before_corrective"
                            :key="index"
                            style="
                              padding: 0;
                              height: 100px;
                              width: 100px;
                              background-color: black;
                              margin: 5px;
                              position: relative;
                              border: 2px solid black;
                              border-radius: 5px;
                            "
                          >
                            <v-img
                              :src="item.file"
                              :lazy-src="`https://picsum.photos/10/6?image=${
                                index * 5 + 10
                              }`"
                              style="
                                width: 100%;
                                height: 100%;
                                border-radius: 5px;
                                cursor: pointer;
                              "
                              class="grey lighten-2"
                              @click="openImage(item, 'vefore')"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <div
                              v-if="detailData.status.id == 0 && !isEdit"
                              class="d-flex justify-center align-center"
                              style="
                                position: absolute;
                                bottom: 0;
                                right: 0;
                                height: 30px;
                                width: 30px;
                                background-color: red;
                                border: 1px solid black;
                                border-radius: 15px 0 0 0;
                              "
                            >
                              <v-btn
                                @click="
                                  deletePhoto(
                                    item.file.slice(
                                      item.file.lastIndexOf('/') + 1
                                    ),
                                    'before'
                                  )
                                "
                                rounded
                                small
                                elevation="0"
                                icon
                              >
                                <v-icon color="white">mdi-delete</v-icon>
                              </v-btn>
                            </div>
                            <p
                              style="
                                margin: 0;
                                font-size: 12px;
                                height: 40px;
                                line-height: 1;
                                padding-top: 1px;
                                overflow: hidden;
                              "
                            >
                              {{ item.subject }}
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider
                      v-if="detailData.status.id == 0 && !isEdit"
                    ></v-divider>

                    <v-card-actions v-if="detailData.status.id == 0 && !isEdit">
                      <v-btn
                        elevation="0"
                        small
                        outlined
                        style="margin-right: auto"
                        :loading="loading"
                        color="primary"
                        @click="openUploadModal('upload', 'before')"
                      >
                        <v-icon small style="margin-right: 5px"
                          >mdi-upload</v-icon
                        >
                        <span :style="`font-weight: bold;`">Tambah File</span>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="error"
                        small
                        outlined
                        :loading="loading"
                        @click="deleteAllFile('before')"
                      >
                        <v-icon small style="margin-right: 5px"
                          >mdi-delete</v-icon
                        >
                        <span :style="`font-weight: bold;`">Delete All</span>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
                <!-- Tindakan Perbaikan -->
                <div
                  v-else-if="index == 3"
                  style="min-height: 40vh; margin-top: 15px"
                >
                  <v-card elevation="0">
                    <v-form
                      :readonly="!isEdit"
                      ref="rootProblemReportFormRef"
                      @submit.prevent="saveForm"
                      style="margin: 10px 0"
                    >
                      <v-row>
                        <v-col cols="12" md="4" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Due Date Perbaikan
                          </p>
                          <v-text-field
                            v-model="detailData.corrective_due_date"
                            dense
                            :clearable="isEdit"
                            :outlined="isEdit"
                            style="height: 35px"
                            type="date"
                          />
                        </v-col>
                        <!-- <v-col cols="12" md="4" class="d-flex flex-column">
                          <p
                            class="text-left"
                            style="
                              margin: 0;
                              font-size: 12px;
                              font-weight: bold;
                              color: rgba(0, 0, 0, 0.5);
                            "
                          >
                            Status Perbaikan
                          </p>
                          <v-autocomplete
                            v-model="detailData.corrective_status"
                            :items="[
                              {id: 0, name: 'Unverified'},
                              {id: 1, name: 'Verified'}
                            ]"
                            item-text="name"
                            item-value="id"
                            return-id
                            dense
                            :clearable="isEdit"
                            :outlined="isEdit"
                            style="height: 45px"
                          ></v-autocomplete>
                        </v-col> -->
                        <v-col cols="12">
                          <div v-if="isEdit" style="overflow: hidden">
                            <!-- vue editor deprecated its causing DOMNodeInserted warning -->
                            <vue-editor
                              v-model="detailData.corrective_recomendation"
                              class="textEditor"
                            ></vue-editor>
                          </div>
                          <div v-else>
                            <div
                              v-if="detailData.corrective_recomendation"
                              v-html="detailData.corrective_recomendation"
                              style="
                                padding: 15px;
                                border: 1px solid rgba(0, 0, 0, 0.1);
                              "
                            ></div>
                            <v-card
                              v-else
                              flat
                              height="30vh"
                              style="
                                display: flex;
                                justify-content: center;
                                align-items: center;
                              "
                            >
                              <v-toolbar-title class="overline">
                                Data Not Found</v-toolbar-title
                              >
                            </v-card>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card>
                </div>
                <!-- Dokumentasi After -->
                <div v-else-if="index == 4" style="min-height: 40vh">
                  <v-card elevation="0">
                    <v-card-text class="d-flex justify-center align-center">
                      <v-row>
                        <v-col
                          v-if="
                            detailData.after_corrective == null ||
                            detailData.after_corrective.length == 0
                          "
                          cols="12"
                          class="d-flex justify-center align-center"
                          style="padding: 0; min-height: 20vh"
                        >
                          <div
                            style="
                              padding: 0 10px;
                              color: grey;
                              font-weight: bold;
                              font-size: 14px;
                            "
                          >
                            BELUM ADA PHOTO
                          </div>
                        </v-col>

                        <v-col
                          v-else
                          cols="12"
                          style="min-height: 20vh"
                          class="d-flex"
                        >
                          <div
                            v-for="(item, index) in detailData.after_corrective"
                            :key="index"
                            style="
                              padding: 0;
                              height: 100px;
                              width: 100px;
                              background-color: black;
                              margin: 5px;
                              position: relative;
                              border: 2px solid black;
                              border-radius: 5px;
                            "
                          >
                            <v-img
                              :src="item.file"
                              :lazy-src="`https://picsum.photos/10/6?image=${
                                index * 5 + 10
                              }`"
                              style="
                                width: 100%;
                                height: 100%;
                                border-radius: 5px;
                                cursor: pointer;
                              "
                              class="grey lighten-2"
                              @click="openImage(item, 'after')"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>

                            <div
                              v-if="detailData.status.id == 0 && !isEdit"
                              class="d-flex justify-center align-center"
                              style="
                                position: absolute;
                                bottom: 0;
                                right: 0;
                                height: 30px;
                                width: 30px;
                                background-color: red;
                                border: 1px solid black;
                                border-radius: 15px 0 0 0;
                              "
                            >
                              <v-btn
                                @click="
                                  deletePhoto(
                                    item.file.slice(
                                      item.file.lastIndexOf('/') + 1
                                    ),
                                    'after'
                                  )
                                "
                                rounded
                                small
                                elevation="0"
                                icon
                              >
                                <v-icon color="white">mdi-delete</v-icon>
                              </v-btn>
                            </div>
                            <p
                              style="
                                margin: 0;
                                font-size: 12px;
                                height: 40px;
                                line-height: 1;
                                padding-top: 1px;
                                overflow: hidden;
                              "
                            >
                              {{ item.subject }}
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-divider
                      v-if="detailData.status.id == 0 && !isEdit"
                    ></v-divider>

                    <v-card-actions v-if="detailData.status.id == 0 && !isEdit">
                      <v-btn
                        elevation="0"
                        small
                        outlined
                        style="margin-right: auto"
                        :loading="loading"
                        color="primary"
                        @click="openUploadModal('upload', 'after')"
                      >
                        <v-icon small style="margin-right: 5px"
                          >mdi-upload</v-icon
                        >
                        <span :style="`font-weight: bold;`">Tambah File</span>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="error"
                        small
                        outlined
                        :loading="loading"
                        @click="deleteAllFile('after')"
                      >
                        <v-icon small style="margin-right: 5px"
                          >mdi-delete</v-icon
                        >
                        <span :style="`font-weight: bold;`">Delete All</span>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
                <!-- Approval -->
                <div v-else-if="index == 5" style="min-height: 40vh">
                  <v-row no-gutters style="padding: 0">
                    <v-col md="12" style="padding: 0">
                      <v-data-table
                        mobile-breakpoint="0"
                        fixed-header
                        height="50vh"
                        :headers="approvalHeaders"
                        :items="
                          detailData.approval_matrix != null
                            ? detailData.approval_matrix
                            : []
                        "
                        :items-per-page="10"
                        class="elevation-1 mx-auto"
                        hide-default-footer
                      >
                        <template v-slot:[`item.document_no`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.document_no }}
                          </div>
                        </template>
                        <template v-slot:[`item.table_name`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.table_name }}
                          </div>
                        </template>
                        <template v-slot:[`item.approver_user`]="{ item }">
                          <div style="cursor: pointer" v-if="item">
                            <v-chip
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                              v-for="(item, index) in item.approver_user"
                              :key="index"
                            >
                              {{ item.user !== null ? item.user.name : '-' }}
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.approved`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px"
                          >
                            <v-chip
                              v-if="items.status === 1"
                              label
                              outlined
                              small
                              style="
                                position: relative;
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                                border: 1px solid rgba(0, 0, 0, 0.5);
                              "
                            >
                              {{ item.user !== null ? items.user.name : '-' }}
                              <v-tooltip bottom color="primary">
                                <template v-slot:activator="{ attrs, on }">
                                  <div
                                    v-if="items.note"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="openCommentDialog(items)"
                                    style="
                                      position: absolute;
                                      top: 0;
                                      right: 0;
                                      width: 20px;
                                      bottom: 0;
                                      background: white;
                                    "
                                  >
                                    <v-icon small color="info"
                                      >mdi-comment-alert</v-icon
                                    >
                                  </div>
                                </template>
                                <span>Klik untuk melihat catatan</span>
                              </v-tooltip>
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.rejected`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px"
                          >
                            <v-chip
                              v-if="items.status === -1"
                              label
                              outlined
                              small
                              style="
                                margin-right: 5px;
                                padding: 0 3px;
                                cursor: pointer;
                              "
                            >
                              {{ item.user !== null ? items.user.name : '-' }}
                              <v-tooltip bottom>
                                <template v-slot:activator="{ attrs, on }">
                                  <div
                                    v-if="items.note"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="openCommentDialog(items)"
                                    style="
                                      position: absolute;
                                      top: 0;
                                      right: 0;
                                      width: 20px;
                                      bottom: 0;
                                      background: white;
                                    "
                                  >
                                    <v-icon small color="info"
                                      >mdi-comment-alert</v-icon
                                    >
                                  </div>
                                </template>
                                <span>Klik untuk melihat catatan</span>
                              </v-tooltip>
                            </v-chip>
                          </div>
                        </template>
                        <template v-slot:[`item.created_at`]="{ item }">
                          <div style="width: 140px; font-size: 12px">
                            {{ item.created_at }}
                          </div>
                        </template>
                        <template v-slot:[`item.updated_at`]="{ item }">
                          <div
                            v-for="(items, index) in item.approver_user"
                            :key="index"
                            style="width: 140px; font-size: 12px"
                          >
                            <span v-if="items.status === 1">
                              {{
                                items.updated_at !== null
                                  ? items.updated_at
                                  : '-'
                              }}
                            </span>
                            <br v-if="index > 0" />
                          </div>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                  <div
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.picK3 ||
                          id == appLevel.administrator
                      ) !== undefined
                    "
                  >
                    <div
                      style="text-align: left; padding-left: 5px"
                      v-if="detailData.status.id == 1"
                    >
                      <v-btn
                        color="grey"
                        tile
                        dark
                        small
                        dense
                        style="font-size: 10px; width: 100px; margin-top: 10px"
                        :loading="loading"
                        @click="fetchMatrix"
                      >
                        <span>Fetch Matrix</span>
                      </v-btn>
                    </div>
                  </div>
                </div>
                <div v-else style="min-height: 40vh; margin-top: 15px"></div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>

        <v-dialog v-model="commentDialog" width="500" persistent>
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Catatan Approval
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="margin: 0; font-weight: bold"
                      v-if="commentNote != null"
                    >
                      {{ commentNote.note }}
                    </p>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="error" text outlined @click="closeCommentDialog">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="uploadDialog" width="500" persistent>
          <v-form
            :disabled="loading"
            lazy-validation
            ref="entryFormUpload"
            @submit.prevent="submitUploadDoc"
            style="position: relative"
          >
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                UPLOAD
              </v-card-title>

              <v-card-text class="d-flex justify-center align-center">
                <v-col
                  md="12"
                  style="padding: 0; position: relative; top: 20px"
                >
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Subject
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div>
                        <v-text-field
                          outlined
                          v-model="file_subject"
                          dense
                          :rules="rules.subjectRules"
                        ></v-text-field>
                      </div>
                      <div
                        style="
                          padding: 10px;
                          border: 2px dashed grey;
                          height: 70px;
                        "
                      >
                        <v-file-input
                          ref="uploadDoc"
                          placeholder="Pilih File"
                          dense
                          append-icon="mdi-paperclip"
                          prepend-icon=""
                          @change="uploadFile"
                          :rules="rules.docRules"
                        ></v-file-input>
                      </div>
                    </v-col>
                  </div>
                </v-col>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  id="closeFileUpload"
                  color="error"
                  text
                  outlined
                  type="reset"
                  @click="openUploadModal('close')"
                  :loading="loading"
                >
                  close
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  text
                  outlined
                  type="submit"
                  :loading="loading"
                  :disabled="fileName === '' || file_subject === ''"
                >
                  simpan file
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog v-model="imageDialog" persistent>
          <div style="position: relative">
            <v-btn
              style="
                position: absolute;
                z-index: 1;
                top: 10px;
                right: 10px;
                font-weight: bolder;
              "
              fab
              x-small
              color="black"
              @click="imageDialog = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>

            <div
              style="
                margin: auto;
                height: 600px;
                width: 800px;
                position: relative;
              "
            >
              <v-img
                contain
                :style="`
                            position: relative;
                            width: ${image.width}px;
                            height: ${image.height}px;
                            transform: rotate(${image.deg}deg) ${image.translate};
                        transform-origin: ${image.origin};`"
                :src="
                  imageLink != null
                    ? imageLink
                    : 'https://e-sanqua.sanquawater.co.id/image/ecatalogue/products/photo_1/ProductPhoto-jahsors8yollrrbjwsyx7.png'
                "
                @error="imgError"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <div
                v-if="imageLink != null"
                class="d-flex justify-center align-center"
                style="position: absolute; bottom: 10px; left: 360px"
              >
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="rotateImage('left')"
                      v-bind="attrs"
                      v-on="on"
                      style="
                        font-weight: bolder;
                        margin-right: 5px;
                        background-color: rgba(255, 255, 255, 0.8);
                      "
                      fab
                      x-small
                      color="white"
                    >
                      <v-icon color="black">mdi-rotate-left</v-icon>
                    </v-btn>
                  </template>
                  <span>rotate left</span>
                </v-tooltip>
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="downloadImage"
                      v-bind="attrs"
                      v-on="on"
                      style="
                        font-weight: bolder;
                        margin-right: 5px;
                        background-color: rgba(255, 255, 255, 0.8);
                      "
                      fab
                      x-small
                      color="white"
                    >
                      <v-icon color="green">mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>download</span>
                </v-tooltip>
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="rotateImage('right')"
                      v-bind="attrs"
                      v-on="on"
                      style="
                        font-weight: bolder;
                        background-color: rgba(255, 255, 255, 0.8);
                      "
                      fab
                      x-small
                    >
                      <v-icon color="black">mdi-rotate-right</v-icon>
                    </v-btn>
                  </template>
                  <span>rotate right</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        </v-dialog>
      </div>

      <!-- <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline"> Data Not Found</v-toolbar-title>
      </v-card> -->
    </div>
    <div v-else>
      <v-card
        class="mx-auto"
        width="100%"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          position: relative;
          top: 0;
          height: 70vh;
          left: 0;
          right: 0;
          background: rgba(255, 255, 255);
        "
      >
        <v-progress-circular :size="100" :width="5" color="blue" indeterminate
          >Loading...</v-progress-circular
        >
      </v-card>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../../services/buildType'
import moment from 'moment'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'rootproblemreportdetail',
  props: ['initialreport', 'appLevel', 'getdropdown'],
  data() {
    return {
      config: require('../../../../../services/config.json')[env],
      build: process.env.VUE_APP_BUILD_TYPE,
      oAuthApi: buildType.apiURL('oauth'),
      dssApi: buildType.apiURL('dss'),
      eSanqua: buildType.apiURL('esanqua'),
      uploadApi: buildType.apiURL('upload2'),
      detailData: null,
      isEdit: false,
      isLoadingPage: true,
      loading: false,
      isDisableCompanyDropdown: false,
      skeleton_loading: true,

      rules: {
        nameRules: [],
        docRules: [],
        subjectRules: []
      },
      dropdown: {
        company: [],
        desccategory: []
      },

      tab: null,
      panel: [],
      isAllowApprove: false,
      commentDialog: false,
      commentNote: null,
      uploadDialog: false,
      fileName: '',
      file_subject: null,
      imageDialog: false,
      imageLink: null,
      image: {
        width: 800,
        height: 600,
        deg: 0,
        translate: '',
        origin: 'top left'
      },
      fileType: null
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  async mounted() {
    // if (this.initialreport.root_problem_report != null) {
    //   this.initDataForLayout()
    // }

    if (this.rootCauseSection.length > 0) {
      for (let i = 0; i < this.rootCauseSection.length; i++) {
        this.panel.push(i)
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    rootCauseSection() {
      const xArr = [
        'Penyebab Insiden',
        'Kesimpulan',
        'Dokumentasi Kejadian/Lokasi Kejadian/Pemeriksaan & Pengkajian',
        'Tindakan Perbaikan',
        'Dokumentasi Setelah Perbaikan',
        'Approval'
      ]
      return xArr
    },
    approvalHeaders() {
      const arrHeaders = [
        { text: 'Seq', value: 'sequence', align: 'left' },
        { text: 'Doc. No', value: 'document_no', align: 'left' },
        { text: 'Model', value: 'table_name', align: 'center' },
        { text: 'User', value: 'approver_user', align: 'center' },
        {
          text: 'Min Acc',
          value: 'min_approver',
          align: 'center'
        },
        {
          text: 'Approved',
          value: 'approved',
          align: 'center'
        },
        {
          text: 'Rejected',
          value: 'rejected',
          align: 'center'
        },
        {
          text: 'CreatedAt',
          value: 'created_at',
          align: 'center'
        },
        {
          text: 'UpdateAt',
          value: 'updated_at',
          align: 'center'
        }
      ]
      return arrHeaders
    }
  },
  watch: {},
  methods: {
    async initDropdown() {
      this.getDropdownAccidentDesc()
    },
    async getDataFromApi() {
      if (this.initialreport.root_problem_report != null) {
        this.loading = true
        const url = `${this.dssApi}rootproblemreport/detail/${this.initialreport.root_problem_report.id}`
        console.log('rootproblemreport.getDataFromApi >>>', url)
        await axios
          .get(url)
          .then((res) => {
            console.log('Detaill >>>', res)
            if (res.data.status_code == '00') {
              this.loading = false
              this.detailData = res.data.data

              if (this.detailData.corrective_due_date != null) {
                this.detailData.corrective_due_date = moment(
                  this.detailData.corrective_due_date
                ).format('YYYY-MM-DD')
              }
              if (res.data.data.status.id == 1) {
                this.authorityCheck(res.data.data)
              }
              this.initDropdown()
            } else {
              this.loading = false
            }
          })
          .catch((err) => {
            console.log(err)
            this.loading = false
          })
      } else {
        console.log(
          'Detaill Inspection>>>',
          this.initialreport.root_problem_report
        )
      }
    },
    enableEdit() {
      this.isEdit = !this.isEdit

      if (!this.isEdit) {
        this.getDataFromApi()
      }
    },
    saveForm() {
      const exclude = [
        'created_at',
        'created_by',
        'created_by_name',
        'updated_at',
        'updated_by',
        'updated_by_name',
        'initialreport_id',
        'status',
        'document_no',
        'root_cause',
        'before_corrective',
        'after_corrective',
        'initial_report',
        'approval_matrix'
      ]
      // Build form object by filtering out excluded fields and null values
      const form = Object.keys(this.detailData)
        .filter((key) => !exclude.includes(key) && this.detailData[key] != null)
        .reduce((obj, key) => {
          obj[key] = this.detailData[key]
          return obj
        }, {})
      console.log('gform>>>', form)

      this.createNewForm(form)
    },
    createNewForm(oldForm) {
      const xNewForm = {
        act: 'update',
        id: this.detailData.id,
        conclusion: oldForm.conclusion,
        corrective_recomendation: oldForm.corrective_recomendation,
        corrective_due_date: oldForm.corrective_due_date,
        corrective_status: oldForm.corrective_status
      }

      // if (xNewForm.conclusion && xNewForm.corrective_recomendation) {
      //   console.log('Final Form>>>', xNewForm)
      this.submitForm(xNewForm)
      // }
      this.saveFormUraian()
    },
    async submitForm(form) {
      this.loading = true
      console.log(form)
      await axios
        .post(`${this.dssApi}rootproblemreport/save`, form)
        .then(async (res) => {
          this.loading = false
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.enableEdit()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          this.loading = false
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },

    getDropdownAccidentDesc() {
      const url = `${this.dssApi}master/universal/causecategory/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            console.log(res.data.data)
            this.dropdown.desccategory = res.data.data
            const xArrItemDesc = this.detailData.root_cause
            for (let i = 0; i < this.dropdown.desccategory.length; i++) {
              if (i < 6) {
                const itemDesc = xArrItemDesc.find(
                  ({ cause_category }) =>
                    cause_category.id == this.dropdown.desccategory[i].id
                )
                this.dropdown.desccategory[i].description =
                  itemDesc != null ? itemDesc.description : null
              }
            }
            console.log(
              'this.dropdown.desccategory',
              this.dropdown.desccategory
            )
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    submitReportDocument() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.detailData.id
          }
          axios
            .post(`${this.dssApi}rootproblemreport/submit`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetchMatrix()
                // } else {
                this.getDataFromApi()
                this.$emit('loadPage')
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    cancelReportDocument() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin cancel dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.detailData.id,
            note: res.value
          }
          axios
            .post(`${this.dssApi}rootproblemreport/cancel`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                this.$emit('loadPage')
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    setDraftReport() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin SET DRAFT dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.detailData.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}rootproblemreport/set_to_draft`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                this.$emit('loadPage')
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    verifyReport() {
      this.showMsgDialog(
        'question',
        'Verify dokumen ini sekarang ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.detailData.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}rootproblemreport/verify`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                this.$emit('loadPage')
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    confirmReportDocument() {
      this.showMsgDialog2('question', 'Confirm dokumen ini ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              document_id: this.detailData.id,
              note: res.value
            }
            axios
              .post(`${this.dssApi}rootproblemreport/approve`, form)
              .then(async (res) => {
                this.loading = false
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                  this.getDataFromApi()
                  this.$emit('loadPage')
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              })
              .catch((err) => {
                this.showMsgDialog('error', err, false)
                this.loading = false
              })
          }
        }
      )
    },
    rejectReportDocument() {
      this.showMsgDialog2('question', 'Reject dokumen ini ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              document_id: this.detailData.id,
              note: res.value
            }
            axios
              .post(`${this.dssApi}rootproblemreport/reject`, form)
              .then(async (res) => {
                this.loading = false
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                  this.getDataFromApi()
                  this.$emit('loadPage')
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              })
              .catch((err) => {
                this.showMsgDialog('error', err, false)
                this.loading = false
              })
          }
        }
      )
    },
    authorityCheck(item) {
      if (item.approval_matrix !== null) {
        const matrixId = item.approval_matrix[0].document_id
        axios
          .get(
            `${this.oAuthApi}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=23&table_name=tr_rootproblems`
          )
          .then((res) => {
            console.log('AuthorityCheck>>>', res)

            if (res.data.status_code === '00') {
              if (res.data.is_allow_approve !== 0) {
                this.isAllowApprove = true
              } else {
                this.isAllowApprove = false
              }
            } else {
              this.isAllowApprove = false
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Cek Otoritas error, Silahkan info ke Admin'
                : 'Cek Otoritas error, Silahkan info ke Admin',
              false
            )
          })
      }
    },
    async fetchMatrix() {
      this.loading = true
      const form = {
        id: this.detailData.id
        // approval_matrix_id: this.detailData.approval_matrix[0].document_id
      }
      await axios
        .post(`${this.dssApi}rootproblemreport/fetch_matrix`, form)
        .then(async (res) => {
          if (res.data.status_code == '00') {
            if (res.data.approval_matrix_result.status_code == '00') {
              this.getDataFromApi()
            } else {
              this.showMsgDialog(
                'warning',
                res.data.approval_matrix_result.status_msg,
                false
              )
            }
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          this.loading = false
          this.showMsgDialog(
            res.data.status_code == '00' ? 'success' : 'warning',
            res.data.status_msg,
            false
          )
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    saveFormUraian() {
      const list = this.dropdown.desccategory
      const xArrItemDesc = this.detailData.root_cause
      for (let i = 0; i < list.length; i++) {
        if (i < 6) {
          const form = {
            description: this.dropdown.desccategory[i].description,
            cause_category_id: this.dropdown.desccategory[i].id
          }

          const itemDesc = xArrItemDesc.find(
            ({ cause_category }) =>
              cause_category.id == this.dropdown.desccategory[i].id
          )

          if (itemDesc != undefined && itemDesc != null) {
            Object.assign(form, {
              act: 'update',
              id: itemDesc.id
            })
          } else {
            Object.assign(form, {
              act: 'add',
              rootproblem_id: this.detailData.id
            })
          }

          if (
            form.description != undefined &&
            form.description != null &&
            form.description != ''
          ) {
            console.log('save desc>>>', form)
            this.submitFormUraian(form)
          }
        }
      }
    },
    async submitFormUraian(form) {
      await axios
        .post(`${this.dssApi}rootproblemreport/rootcausedesc/save`, form)
        .then(async (res) => {
          if (res.data.status_code == '00') {
            return {
              status_code: '00',
              cause_category_id: form.cause_category_id
            }
          }

          return {
            status_code: '-99',
            cause_category_id: form.cause_category_id
          }
        })
        .catch((err) => {
          return {
            status_code: '-99',
            err_msg: `${err.message}`,
            cause_category_id: form.cause_category_id
          }
        })
    },
    openUploadModal(event, type) {
      if (event === 'upload') {
        this.fileType = type
        setTimeout(() => {
          this.uploadDialog = true
        }, 500)
      }
      if (event === 'close') {
        if (this.fileName !== '') {
          let fName = ''
          fName = this.fileName
          this.unlinkDokumen(fName, true)
          this.file_subject = null
          // this.$refs.uploadDoc.reset()
        }
        if (this.$refs.entryFormUpload) {
          this.$refs.entryFormUpload.reset()
        }
        setTimeout(() => {
          this.uploadDialog = false
        }, 500)
      }
      this.fileName = ''
    },
    deletePhoto(photoName, type) {
      this.fileType = type
      this.showMsgDialog('question', 'Hapus photo, Anda yakin ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.unlinkDokumen(photoName, false)
          }
        }
      )
    },
    unlinkDokumen(fName, pValue) {
      // console.log('Unlink>>>', fName)
      this.loading = true
      const data = {
        module: 'k3',
        file_name: fName
      }
      axios
        .post(`${this.uploadApi}esanqua/dss/unlink`, data)
        .then((res) => {
          // console.log('Unlink>>>>>', res)
          if (res.data.status_code === '00') {
            this.fileName = ''
            if (!pValue) {
              this.removeFileFromDetail(fName)
            }
          } else {
            this.showMsgDialog('warning', res.data.status_msg, false)
            if (!pValue) {
              if (res.data.status_msg === 'File not found') {
                this.removeFileFromDetail(fName)
              }
            }
          }
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
        })
    },
    removeFileFromDetail(fName) {
      // console.log('removeFileFromDetail>>', fName, this.detailData.file)\
      if (this.fileType == 'before') {
        for (let i = 0; i < this.detailData.before_corrective.length; i++) {
          if (this.detailData.before_corrective[i].file.includes(fName)) {
            this.detailData.before_corrective.splice(i, 1)
          }
        }
      }
      if (this.fileType == 'after') {
        for (let i = 0; i < this.detailData.after_corrective.length; i++) {
          if (this.detailData.after_corrective[i].file.includes(fName)) {
            this.detailData.after_corrective.splice(i, 1)
          }
        }
      }
      // console.log('this.detailData.file after>>', this.detailData.file)
      this.updatePhoto(false)
    },
    uploadFile(event) {
      if (event !== null) {
        if (event.size <= 1024 * 1024 * 2) {
          // this.loading = true;
          const data = new FormData()
          data.append('file', event)
          data.append('module', 'k3')
          axios
            .post(`${this.uploadApi}esanqua/dss`, data)
            .then((res) => {
              if (res.data.status === true) {
                this.showMsgDialog(
                  'success',
                  'File siap disimpan, Silahkan lanjutkan dengan klik tombol "simpan file"',
                  false
                )
                this.fileName = res.data.data.name
                // setTimeout(() => {
                //   this.submitUploadDoc()
                // }, 200)
              } else {
                this.showMsgDialog('warning', res.data.message, false)
              }
              // this.loading = false;
            })
            .catch((err) => {
              // this.loading = false;
              this.showMsgDialog('error', err.message, false)
            })
        } else {
          setTimeout(() => {
            this.showMsgDialog('warning', 'Max size = 2MB', false)
            this.fileName = ''
          }, 300)
        }
      } else {
        this.fileName = ''
        // this.$refs.uploadDoc.reset()
      }
    },
    submitUploadDoc() {
      this.rules.docRules = [(v) => !!v || 'Tidak ada file yang terupload']
      this.rules.subjectRules = [(v) => !!v || 'Kolom Subject diperlukan']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryFormUpload.validate()) {
          self.updatePhoto(true)
        }
      })
    },

    async updatePhoto(isAddFile) {
      // this.loading = true
      console.log('upload form>>>', this.detailData)
      const file = []
      let correctiveFile = []
      if (this.fileType == 'before') {
        correctiveFile = this.detailData.before_corrective
      } else if (this.fileType == 'after') {
        correctiveFile = this.detailData.after_corrective
      }

      if (correctiveFile != null) {
        for (let i = 0; i < correctiveFile.length; i++) {
          const fName = correctiveFile[i].file.slice(
            correctiveFile[i].file.lastIndexOf('/') + 1
          )
          file.push({
            subject: correctiveFile[i].subject,
            file: fName
          })
        }
      }
      if (isAddFile) {
        file.push({
          subject: this.file_subject,
          file: this.fileName
        })
      }
      const form = {
        id: this.detailData.id
      }

      if (this.fileType == 'before') {
        Object.assign(form, {
          before_corrective: file
        })
      } else if (this.fileType == 'after') {
        Object.assign(form, {
          after_corrective: file
        })
      }

      console.log('upload form>>>', form)
      await axios
        .post(`${this.dssApi}upload/k3/update_file_upload`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            this.showMsgDialog('success', 'File berhasil disimpan', false)
            this.file_subject = null
            this.fileName = ''
            if (document.getElementById('closeFileUpload') != null) {
              document.getElementById('closeFileUpload').click()
            }
            this.detailData.before_corrective = []

            if (this.fileType == 'before') {
              this.detailData.before_corrective = []
            } else if (this.fileType == 'after') {
              this.detailData.after_corrective = []
            }

            setTimeout(() => {
              for (let i = 0; i < file.length; i++) {
                if (this.fileType == 'before') {
                  this.detailData.before_corrective.push({
                    subject: file[i].subject,
                    file: 'http://10.10.20.8:8020/dss/k3/' + file[i].file
                  })
                } else if (this.fileType == 'after') {
                  this.detailData.after_corrective.push({
                    subject: file[i].subject,
                    file: 'http://10.10.20.8:8020/dss/k3/' + file[i].file
                  })
                }
              }
              // console.log('this.evidenceFile>>>>', this.evidenceFile);
              this.getDataFromApi()
            }, 300)
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
            this.unlinkDokumen(this.fileName, false)
          }
        })
        .catch((err) => {
          this.loading = false
          this.showMsgDialog('error', err.message, false)
          this.fileName = ''
          // this.$refs.entryFormUpload.reset()
        })
    },

    async deleteAllFile(type) {
      this.showMsgDialog(
        'question',
        'Semua file akan terhapus, Anda yakin ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          // this.loading = true
          const arrFileName = []
          let correctiveFile = []
          if (type == 'before') {
            correctiveFile = this.detailData.before_corrective
          } else if (type == 'after') {
            correctiveFile = this.detailData.after_corrective
          }

          for (let i = 0; i < correctiveFile.length; i++) {
            const fileName = correctiveFile[i].file.slice(
              correctiveFile[i].file.lastIndexOf('/') + 1
            )
            const data = {
              module: 'k3',
              file_name: fileName
            }
            await axios
              .post(`${this.uploadApi}esanqua/dss/unlink`, data)
              .then((res) => {
                // console.log(`Unlink-${i + 1}>>>`, res)
                if (res.data.status_code === '00') {
                  arrFileName.push(fileName)
                }
                return null
              })
              .catch((err) => {
                console.log(`Err Unlink-${i + 1}>>>`, err)
                return null
              })
          }
          // console.log('deleteAll>>>>>', arrFileName)
          const form = {
            id: this.detailData.id
          }

          if (type == 'before') {
            Object.assign(form, {
              before_corrective: []
            })
          } else if (type == 'after') {
            Object.assign(form, {
              after_corrective: []
            })
          }

          await axios
            .post(`${this.dssApi}upload/k3/update_file_upload`, form)
            .then((res) => {
              if (res.data.status_code === '00') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    openImage(img) {
      this.imageLink = null

      this.imageLink = img.file
      this.image.width = 800
      this.image.height = 600
      this.image.deg = 0
      this.image.translate = ''
      this.image.origin = 'top left'
      setTimeout(() => {
        this.imageDialog = true
      }, 300)
    },
    imgError() {
      // console.log('error image')
      // this.isImgError = true
      this.imageLink =
        'https://e-sanqua.sanquawater.co.id/image/ecatalogue/products/photo_1/ProductPhoto-jahsors8yollrrbjwsyx7.png'
    },
    downloadImage() {
      const fileName = this.imageLink.slice(this.imageLink.lastIndexOf('/'))
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = this.imageLink
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    rotateImage(str) {
      if (this.image.deg == -270 || this.image.deg == 270) {
        this.image.deg = 0
      } else {
        if (str == 'left') {
          this.image.deg = this.image.deg - 90
        }
        if (str == 'right') {
          this.image.deg = this.image.deg + 90
        }
      }
      // console.log(this.image.translate)
      if (this.image.translate == '') {
        this.image.width = 600
        this.image.height = 800
        // this.image.origin = 'top left'
        //   this.image.translate = 'translateY(-100%)'
      } else {
        this.image.width = 800
        this.image.height = 600
        // this.image.origin = ''
        //   this.image.translate = ''
      }
      // console.log(this.image.deg)
      if (
        this.image.deg == 0 ||
        this.image.deg == 180 ||
        this.image.deg == -180
      ) {
        this.image.translate = ''
        this.image.origin = ''
      }

      if (this.image.deg == -90 || this.image.deg == 270) {
        this.image.translate = 'translateX(-100%)'
        this.image.origin = 'top left'
      }
      if (this.image.deg == 90 || this.image.deg == -270) {
        this.image.translate = 'translateY(-100%)'
        this.image.origin = 'top left'
      }
    },
    openCommentDialog(obj) {
      console.log(obj)
      this.commentNote = obj
      setTimeout(() => {
        this.commentDialog = true
      }, 100)
    },
    closeCommentDialog() {
      this.commentDialog = false
      setTimeout(() => {
        this.commentNote = null
      }, 100)
    },
    initialStatusColor(val) {
      if (val) {
        if (val == null) {
          return 'red'
        } else {
          const arrColour = ['grey', 'orange', 'green', 'red', 'red', 'green']
          return arrColour[val.id]
        }
      }
    },
    toRoman(num) {
      if (isNaN(num)) return ''

      const roman = [
        ['M', 1000],
        ['CM', 900],
        ['D', 500],
        ['CD', 400],
        ['C', 100],
        ['XC', 90],
        ['L', 50],
        ['XL', 40],
        ['X', 10],
        ['IX', 9],
        ['V', 5],
        ['IV', 4],
        ['I', 1]
      ]

      let result = ''
      for (const [symbol, value] of roman) {
        while (num >= value) {
          result += symbol
          num -= value
        }
      }
      return result
    },
    showMsgDialog2(pModalType, pStatusMsg, pBtnCancel, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: 'textarea',
            inputLabel:
              'Tolong isi keterangan pada kolom dibawah sebelum submit',
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, yesBtn, noBtn, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: yesBtn || 'OK',
            cancelButtonText: noBtn || 'NO'
          })
          .then((r) => {
            resolve(r)
          })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-scroll-wrapper {
  max-height: 73vh; /* Or whatever fits your layout */
  overflow-y: auto;
  position: relative;
  padding: 0 15px 0 15px;
  &::-webkit-scrollbar {
    // display: none;
    width: 4px;
    background: aquamarine;
  }
  &::-webkit-scrollbar-thumb {
    background: cornflowerblue;
  }
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 6;
}
</style>
